import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GlobalScope_instance3w3xrcgjszz2p as GlobalScope_instance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { writer1eia5its2a1fh as writer } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteWriteChannelOperations.mjs';
import {
  WriteChannelContent1d7f40hsfcaxg as WriteChannelContent,
  ReadChannelContentz1amb4hnpqp4 as ReadChannelContent,
  NoContent1bdx48poqrifq as NoContent,
  ProtocolUpgradexnnpt2xliy8g as ProtocolUpgrade,
  ByteArrayContent2n0wb43y6ugs1 as ByteArrayContent,
  ContentWrapper3n9gdymgnbto9 as ContentWrapper,
} from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { Companion_getInstance25751un9ltd4f as Companion_getInstance } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { UnsupportedContentTypeException1omj39t4jp3a7 as UnsupportedContentTypeException } from '../call/utils.mjs';
import { ByteReadChannel1cb89sbyipkce as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteChannelCtor.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { observable2pw4p3n7s3klf as observable } from '../utils/ByteChannelUtils.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function getContent($this, delegate) {
  var tmp;
  if (delegate instanceof ContentWrapper()) {
    tmp = getContent($this, delegate.b58());
  } else {
    if (delegate instanceof ByteArrayContent()) {
      tmp = ByteReadChannel(delegate.s57());
    } else {
      if (delegate instanceof ProtocolUpgrade()) {
        throw UnsupportedContentTypeException().d5l(delegate);
      } else {
        if (delegate instanceof NoContent()) {
          tmp = Companion_getInstance().e4l_1;
        } else {
          if (delegate instanceof ReadChannelContent()) {
            tmp = delegate.v57();
          } else {
            if (delegate instanceof WriteChannelContent()) {
              var tmp_0 = GlobalScope_instance;
              tmp = writer(tmp_0, $this.g5l_1, true, ObservableContent$getContent$slambda(delegate)).a4l_1;
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }
  }
  return tmp;
}
function ObservableContent$getContent$slambda($delegate) {
  return constructCallableReference(function *($this$writer, $completion) {
    yield* $delegate.x57($this$writer.k4l_1, $completion);
    return Unit_instance;
  }, 1);
}
var ObservableContentClass;
function ObservableContent() {
  if (ObservableContentClass === VOID) {
    class $ extends ReadChannelContent() {
      constructor(delegate, callContext, listener) {
        super();
        this.f5l_1 = delegate;
        this.g5l_1 = callContext;
        this.h5l_1 = listener;
      }
      s47() {
        return this.f5l_1.s47();
      }
      t47() {
        return this.f5l_1.t47();
      }
      x51() {
        return this.f5l_1.x51();
      }
      v57() {
        return observable(getContent(this, this.f5l_1), this.g5l_1, this.t47(), this.h5l_1);
      }
    }
    initMetadataForClass($, 'ObservableContent');
    ObservableContentClass = $;
  }
  return ObservableContentClass;
}
var ProgressListenerClass;
function ProgressListener() {
  if (ProgressListenerClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ProgressListener', VOID, VOID, VOID, [2]);
    ProgressListenerClass = $;
  }
  return ProgressListenerClass;
}
//region block: exports
export {
  ObservableContent as ObservableContent3ft2pt0w2oysd,
  ProgressListener as ProgressListener886sg277haqw,
};
//endregion

//# sourceMappingURL=ObservableContent.mjs.map
